import React from 'react';
import RecipeEditor from '../Canvas/RecipeEditor';

export default function BlankRecipeExportWrapper({ recipeCardRef, shouldBlank }) {
  return (
    <div
    style={{
      width: '600px',
      margin: '0 auto',
      padding: '0',
      fontSize: '16px',
    }}
    >
      <RecipeEditor
        recipeCardRef={recipeCardRef}
        forceBlank={shouldBlank}
        hidePlaceholders={shouldBlank}
      />
    </div>
  );
}
